/**
 * Valida o digito do CPF, no caso ao ser chamada duas vezes validará os dois últimos digitos
 * @param firstDigit
 * @param cpf
 * @returns
 */
function validarDigitoCPF(firstDigit : boolean, cpf : string){
  let endPos = firstDigit ? 8 : 9
  let weightOffset = firstDigit ? 10 : 11
  let result = 0

  for(let i = 0; i <= endPos; i++){
    let num = weightOffset - i
    result += Number(cpf[i]) * num;
  }
  let digitoEsperado = result % 11
  digitoEsperado === 0 || digitoEsperado === 1 ? digitoEsperado = 0 : digitoEsperado = 11 - digitoEsperado

  let digitoAtual = Number(cpf[endPos + 1])
  return digitoAtual === digitoEsperado
}

/**
 * Valida o campo de números repetidos
 * @param value de 0-9
 * @param length tamanho do campo
 * @returns
 */
function validarDigitoRepetido(value : string, length : number){
  for(let i = 0; i < 10; i++){
    let aux = ""
    aux = aux.padStart(length, i.toString())
    if(value === aux) return false
  }
  return true
}

/**
 * Validar CPF de acordo com as restrições de digito repetido e os dois últimos digitos
 * @param cpf
 * @returns
 */
export function validateCpf(cpf : string){
  let valido = validarDigitoRepetido(cpf, 11) && validarDigitoCPF(true, cpf) && validarDigitoCPF(false, cpf)
  if(!valido){
    return true
  }
  return false
}

/**
 * Valida o digito do CNPJ, no caso ao ser chamada duas vezes validará os dois últimos digitos
 * @param firstDigit
 * @param cnpj
 * @returns
 */
function validarDigitoCnpj(firstDigit : boolean, cnpj : string){
  let startPos = firstDigit ? 11 : 12
  let weightOffset = firstDigit ? 0 : 1
  let result = 0

  for(let i = startPos; i >= 0; i--){
    let weigth = 2 + ((11 + weightOffset - i) % 8)
    result += Number(cnpj[i]) * weigth;
  }
  let digitoEsperado = result % 11
  digitoEsperado === 0 || digitoEsperado === 1 ? digitoEsperado = 0 : digitoEsperado = 11 - digitoEsperado

  let digitoAtual = Number(cnpj[startPos + 1])
  return digitoAtual === digitoEsperado
}

/**
 * Validar CNPJ de acordo com as restrições de digito repetido e os dois últimos digitos
 * @param cnpj
 * @returns
 */
export function validateCnpj(cnpj: string){
  let valido = validarDigitoRepetido(cnpj, 14) && validarDigitoCnpj(true, cnpj) && validarDigitoCnpj(false, cnpj)
  if(!valido){
    return true
  }
  return false
}
